import Reveal from '@/components/base/Reveal';
import { dailyDigest, headlineLead } from '@/mocks/gossip';

export default function IntroStrip() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <div className="grid gap-6 lg:grid-cols-[1.4fr_1fr] lg:gap-10">
            <div className="relative overflow-hidden rounded-lg">
              <div className="h-[280px] w-full md:h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20background%20with%20swirling%20deep%20crimson%20and%20warm%20amber%20ink%20texture%20on%20soft%20cream%20paper%2C%20subtle%20film%20grain%2C%20blurred%20bokeh%20highlights%2C%20calm%20negative%20space%2C%20dramatic%20soft%20shadows%2C%20sophisticated%20gossip%20column%20aesthetic%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=melon-cover-01&orientation=landscape"
                  alt="91吃瓜今日头条封面：抽象暖调杂志质感背景"
                  title="91吃瓜 · 今日头条封面"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                  <i className="ri-fire-line text-xs" aria-hidden="true"></i>
                  {headlineLead.tag}
                </span>
                <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                  {headlineLead.title}
                </h2>
                <p className="mt-2 max-w-2xl text-xs leading-relaxed text-background-100/85 md:text-sm">
                  {headlineLead.summary}
                </p>
                <p className="mt-3 text-[11px] text-background-100/60">{headlineLead.meta}</p>
              </div>
            </div>

            <div className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
              <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{dailyDigest.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{dailyDigest.body}</p>
              <ul className="mt-5 space-y-3">
                {dailyDigest.points.map((point, i) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 font-label text-[10px] font-bold text-accent-800">
                      {i + 1}
                    </span>
                    <span className="text-sm leading-relaxed text-foreground-700">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}